module.exports = {
    init: function()
    {
        var placeholderInputs = document.querySelectorAll(".input-with-placeholder-label input, .input-with-placeholder-label select.form-control");

        function getElementContainer(element) {
            return element.classList.contains('input-with-placeholder-label') 
                ? element 
                : getElementContainer(element.parentElement)
        }

        function setState(input, eventType) {
            var container = getElementContainer(input);

            if(input.value != '' || eventType == 'focus') {
                container.classList.add("field-filled");
            } else {
                container.classList.remove("field-filled");
            }
        }

        document.addEventListener('DOMContentLoaded', function () {
            Array.from(placeholderInputs).forEach(input => {
                setState(input, 'DOMContentLoaded');

                ['blur', 'focus'].forEach(eventType => input.addEventListener(eventType, function() { setState(input, eventType) }));
            });
        });
    }
}